import { render, staticRenderFns } from "./VoteTextRegister.vue?vue&type=template&id=76c448ec&"
import script from "./VoteTextRegister.vue?vue&type=script&lang=js&"
export * from "./VoteTextRegister.vue?vue&type=script&lang=js&"
import style0 from "./VoteTextRegister.vue?vue&type=style&index=0&id=76c448ec&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports